import { makeAutoObservable } from "mobx";

export default class ActivitiesStore {
    constructor() {
        this._mainBanner = [];
        this._mayorMessage = [];
        this._citizensHearingProgram = [];
        this._projects = [];

        this._mainBannerPage = 1;
        this._mainBannerTotalCount = 0;
        this._mainBannerLimit = 10;

        this._mayorMessagePage = 1;
        this._mayorMessageTotalCount = 0;
        this._mayorMessageLimit = 10;

        this._citizensHearingProgramPage = 1;
        this._citizensHearingProgramTotalCount = 0;
        this._citizensHearingProgramLimit = 10;

        this._projectsPage = 1;
        this._projectsTotalCount = 0;
        this._projectsLimit = 10;

        makeAutoObservable(this);
    }

    setMainBanner(mainBanner) {
        this._mainBanner = mainBanner;
    }

    get mainBanner() {
        return this._mainBanner;
    }

    setMayorMessage(mayorMessage) {
        this._mayorMessage = mayorMessage;
    }

    get mayorMessage() {
        return this._mayorMessage;
    }

    setCitizensHearingProgram(citizensHearingProgram) {
        this._citizensHearingProgram = citizensHearingProgram;
    }

    get citizensHearingProgram() {
        return this._citizensHearingProgram;
    }

    setProjects(projects) {
        this._projects = projects;
    }

    get projects() {
        return this._projects;
    }

    setMainBannerPage(page) {
        this._mainBannerPage = page;
    }
    get mainBannerPage() {
        return this._mainBannerPage;
    }

    setMainBannerTotalCount(count) {
        this._mainBannerTotalCount = count;
    }
    get mainBannerTotalCount() {
        return this._mainBannerTotalCount;
    }

    setMainBannerLimit(limit) {
        this._mainBannerLimit = limit;
    }
    get mainBannerLimit() {
        return this._mainBannerLimit;
    }

    setMayorMessagePage(page) {
        this._mayorMessagePage = page;
    }
    get mayorMessagePage() {
        return this._mayorMessagePage;
    }

    setMayorMessageTotalCount(count) {
        this._mayorMessageTotalCount = count;
    }
    get mayorMessageTotalCount() {
        return this._mayorMessageTotalCount;
    }

    setMayorMessageLimit(limit) {
        this._mayorMessageLimit = limit;
    }
    get mayorMessageLimit() {
        return this._mayorMessageLimit;
    }

    setCitizensHearingProgramPage(page) {
        this._citizensHearingProgramPage = page;
    }
    get citizensHearingProgramPage() {
        return this._citizensHearingProgramPage;
    }

    setCitizensHearingProgramTotalCount(count) {
        this._citizensHearingProgramTotalCount = count;
    }
    get citizensHearingProgramTotalCount() {
        return this._citizensHearingProgramTotalCount;
    }

    setCitizensHearingProgramLimit(limit) {
        this._citizensHearingProgramLimit = limit;
    }
    get citizensHearingProgramLimit() {
        return this._citizensHearingProgramLimit;
    }

    setProjectsPage(page) {
        this._projectsPage = page;
    }
    get projectsPage() {
        return this._projectsPage;
    }

    setProjectsTotalCount(count) {
        this._projectsTotalCount = count;
    }
    get projectsTotalCount() {
        return this._projectsTotalCount;
    }

    setProjectsLimit(limit) {
        this._projectsLimit = limit;
    }
    get projectsLimit() {
        return this._projectsLimit;
    }
}
